import { useState } from 'react'

import { isSet } from 'lodash'
import PropTypes from 'prop-types'

import { ConfirmationDialog, LoadingFeedback } from 'components'

import useSnackbar from 'hooks/useSnackbar'

import helpers from 'helpers'
import * as service from 'service'

const UserCompanyRemoveLinkingDialog = ({
  currentUserCompany,
  open,
  setOpen = () => {},
  refresh = () => {},
}) => {
  const snackbar = useSnackbar()

  const [isLoading, setIsLoading] = useState(false)

  const noticeText = () => {
    if (!currentUserCompany) return

    if (isSet(currentUserCompany?.id)) {
      return `Você tem certeza que deseja desvincular o usuário 
            ${currentUserCompany?.user?.name} 
            da empresa ${currentUserCompany?.company?.name}? 
            Após confirmar, esse usuário não terá mais acesso à empresa.`
    }

    return `Você tem certeza que deseja desvincular o usuário da 
            empresa ${currentUserCompany?.company?.name}?`
  }

  const onSubmit = async (currentUserCompany) => {
    try {
      setIsLoading(true)
      await service.dponet.userCompanies.deleteVinculate({
        userCompanyId: currentUserCompany?.id,
      })

      refresh()

      snackbar.open({
        message: 'Usuário foi desvinculado com sucesso!',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Falha ao desvincular usuário!',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
      setOpen(false)
    }
  }

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <ConfirmationDialog
        open={open}
        setOpen={setOpen}
        message={noticeText()}
        buttonText="Confirmar"
        actionAcceptButton={() => onSubmit(currentUserCompany)}
      />
    </>
  )
}

UserCompanyRemoveLinkingDialog.propType = {
  currentUserCompany: PropTypes.object,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  refresh: PropTypes.func,
}

export default UserCompanyRemoveLinkingDialog
